import React from 'react';
import { usePageContext } from '../../../../contexts/PageContext';
import AppHeaderTitle from './AppHeaderTitle';
import AppHeaderIcons from './AppHeaderIcons';
import { FiMenu } from 'react-icons/fi';
import type { AppHeaderMenuItem } from './AppHeaderIcons';
import { FiSettings, FiLogOut } from 'react-icons/fi';

import { useAuth } from 'contexts/AuthContext';
import { useUser } from 'contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'config/route-configuration';
import Button from 'components/ui/buttons/Button';

const AppHeader: React.FC = () => {
  const { pageConfig, toggleSidebar, getHeaderAction } = usePageContext();
  const { logout } = useAuth();
  const { currentUser } = useUser();
  const navigate = useNavigate();
  const fullName =
    `${currentUser?.firstName ?? ''} ${currentUser?.lastName ?? ''}`.trim() || currentUser?.email || 'Account';
  const accountInitial = (currentUser?.firstName?.[0] ?? currentUser?.email?.[0] ?? 'A').toUpperCase();

  if (!pageConfig.title) {
    return null;
  }

  const menuItems: AppHeaderMenuItem[] = [
    {
      id: 'account',
      label: 'Account settings',
      icon: FiSettings,
      onClick: () => navigate(ROUTES.ACCOUNT_SETTINGS),
    },
    {
      id: 'logout',
      label: 'Sign out',
      icon: FiLogOut,
      dividerBefore: true,
      onClick: async () => {
        await logout();
        navigate(ROUTES.LOGIN);
      },
    },
  ];

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {/* Mobile menu button */}
          <button
            onClick={toggleSidebar}
            className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 mr-3 transition-colors duration-200"
          >
            <span className="sr-only">Open sidebar</span>
            {FiMenu({ className: 'h-6 w-6' })}
          </button>

          <AppHeaderTitle title={pageConfig.title} description={pageConfig.description} />
        </div>

        <div className="flex items-center space-x-4">
          {pageConfig.headerButtons && pageConfig.headerButtons.length > 0 && (
            <div className="flex items-center space-x-2">
              {pageConfig.headerButtons.map((button) => (
                <Button key={button.id} variant={button.variant} onClick={getHeaderAction(button.id) ?? button.onClick}>
                  {button.label}
                </Button>
              ))}
            </div>
          )}
          {pageConfig.showIcons && (
            <AppHeaderIcons
              menuItems={menuItems}
              userName={fullName}
              userEmail={currentUser?.email}
              userInitial={accountInitial}
            />
          )}
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
